<div *ngIf="isContract()">
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "generalOptions.title" | translate }}
  </span>
</div>
<!-- DEVIS -->
@if (!isContract()) {
  <div class="flex justify-between py-2 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.formula" | translate }}
    </span>
    <span class="font-app-regular text-darkest text-sm md:text-base">
      {{ details.formulasAndOptionsInformations.formulaName }}
    </span>
  </div>
  <div class="flex justify-between py-2 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.email" | translate }}
    </span>
    <span class="font-app-regular text-darkest text-sm md:text-base">
      {{ details.email }}
    </span>
  </div>
}
<!-- CONTRAT -->
@else {
  <div class="flex justify-between py-2 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "contractCard.effectiveDate" | translate }}
    </span>
    <span class="font-app-regular text-darkest text-sm md:text-base">
      {{ details.effectiveStartDate | date: "dd/MM/yyyy" }}
    </span>
  </div>

  <div class="flex justify-between py-2 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.lastName" | translate }}
    </span>
    <span class="font-app-regular text-darkest text-sm md:text-base">
      {{ details.optionalServicePolicyVm.policyholderLastName }}
    </span>
  </div>
  <div class="flex justify-between py-2 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.firstName" | translate }}
    </span>
    <span class="font-app-regular text-darkest text-sm md:text-base">
      {{ details.optionalServicePolicyVm.policyholderFirstName }}
    </span>
  </div>
  <!-- RISK ITEMS VALUES -->
  @if (riskItemsToDisplay) {
    <div
      class="flex justify-between py-2 text-sm"
      *ngFor="let riskItem of riskItemsToDisplay">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ riskItem.displayName | translate }}
      </span>
      <span class="font-app-regular text-darkest text-sm md:text-base">
        {{ riskItem.value }}
      </span>
    </div>
  }
}
